import { render, staticRenderFns } from "./aracDetay.vue?vue&type=template&id=97622a12"
import script from "./aracDetay.vue?vue&type=script&lang=js"
export * from "./aracDetay.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports